import { cn } from '@modules/lib/lib'

/**
 * カラーチップコンポーネント（色の四角/丸のスウォッチ）.
 * ColorPalette / PresetEditor など、色を扱う UI 全体で共通利用する.
 */
export interface ColorChipProps {
  color: string
  size?: 'sm' | 'md' | 'lg'
  rounded?: boolean
}

const colorChipSizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-10 h-10',
}

export const ColorChip = ({ color, size = 'md', rounded = false }: ColorChipProps) => (
  <span
    className={cn(
      colorChipSizeClasses[size],
      rounded ? 'rounded-full' : 'rounded',
      'border border-black/10 shrink-0',
    )}
    style={{ backgroundColor: color }}
  />
)
